const ListaRelatorioChamadas = () =>
  import(/* webpackChunkName: "group-pabx-relatorio" */ '../_views/ListaRelatorioChamadas')
const AbasRelatorios = () => import(/* webpackChunkName: "group-pabx-relatorio" */ '../_views/AbasRelatorios')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'chamadas',
    component: AbasRelatorios,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'relatoriochamadas',
  },
  {
    path: 'chamadas/lista',
    component: ListaRelatorioChamadas,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'relatoriochamadas/lista',
  },
]
